import { isString } from './type-guards';

export const isValidPhone = (value: unknown): value is string =>
  isString(value)
    ? /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[\s0-9/.-]*$/.test(value)
    : false;

export const toPhoneUri = (value: string): string =>
  isValidPhone(value) ? `tel:${value.replace(/[^\d+]/g, ``)}` : ``;
